/**
 * Created by Aleksandr on 05.06.2024
 */

const TravelMapToolbarItem = function () {
    ToolbarItem.call(this, ToolbarItem.LOCATIONS);

    this.enable();
};

TravelMapToolbarItem.prototype = Object.create(ToolbarItem.prototype);
TravelMapToolbarItem.prototype.constructor = TravelMapToolbarItem;

TravelMapToolbarItem.prototype.onClick = function () {
    cleverapps.focusManager.display({
        focus: "TravelMap",
        action: function (f) {
            new TravelMapWindow();
            cleverapps.focusManager.onceNoWindowsListener = f;
        }

    });
};